import { environment } from "../environments/environment";

const CLIENT_ID = environment.OKTA_CLIENT_ID;
const ISSUER = environment.OKTA_ISSUER;
const OKTA_TESTING_DISABLEHTTPSCHECK = !environment.production;

export default {
  oidc: {
    clientId: `${CLIENT_ID}`,
    issuer: `${ISSUER}`,
    redirectUri: `${window.location.origin}/implicit/callback`,
    scopes: ["openid", "profile", "email", "groups"],
    pkce: true,
    // Renew the access token ~2 min before it actually expires so in-flight
    // requests never see a 401 due to a just-expired token. The tokenManager
    // fires a `renewed` event; the AuthStore / interceptor don't need to
    // handle `expired` as eagerly as before.
    tokenManager: {
      autoRenew: true,
      autoRemove: true,
      expireEarlySeconds: 120,
    },
    testing: {
      disableHttpsCheck: `${OKTA_TESTING_DISABLEHTTPSCHECK}`,
    },
  },
};
